export default "__VITE_ASSET__CSV$gOe0__"